import { motion } from 'framer-motion';

const STATS = [
  { value: '100', suffix: '+', label: 'Happy Customers' },
  { value: '100', suffix: '%', label: 'Vaastu Compliant Plots' },
  { value: '10', suffix: '%', label: 'Less advance' },
  { value: 'EMI', suffix: '', label: 'Facility Available', accent: true },
];

export const Highlights = () => (
  <section data-testid="highlights-section" className="py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-14">
        {STATS.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.7, delay: i * 0.1 }}
            className={`pr-8 ${i > 0 ? 'lg:border-l lg:border-clay lg:pl-10' : ''}`}
            data-testid={`stat-${i}`}
          >
            <span
              className={`font-heading font-extrabold tracking-tighter text-6xl sm:text-7xl lg:text-8xl ${s.accent ? 'text-terra' : 'text-moss'}`}
              data-testid={`stat-value-${i}`}
            >
              {s.value}
              {s.suffix && <span className="text-terra">{s.suffix}</span>}
            </span>
            <p className="mt-3 text-[11px] tracking-[0.22em] text-ink/50 font-medium uppercase">{s.label}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
